<!-- <app-delivery-structure></app-delivery-structure> -->
<script type="text/javascript">
    jQuery(function ($) {
        //Scope Selector dropdown
        $('.scope-selector-toggle span').click(function () { $('.scope-selector').toggleClass('open'); });
        debugger;
        $(document).add('.apply').bind('click', function (e) {
            var parentElement = $('.scope-selector')[0];
            if (!$.contains(parentElement, e.target) || !parentElement == e.target) {
                $('.scope-selector.open').removeClass('open');
            }
        });

        //Scope Selector menu
        $('.ss-menu-wrap li span').click(function () {
            $(this).parent('li').toggleClass('open').siblings('li').removeClass('open').find('li').removeClass('open');
            $(this).parent('li').find('li').removeClass('open');
            $('.ss-menu-wrap li').removeClass('selected');
            $('.ss-menu-wrap li.open').last().addClass('selected');
        });
    });
</script>
<!-- header -->
<header class="myw-app-header myw-container d-flex">
    <div class="myw-brand d-flex align-items-end">
        <img src="assets/images/logo.svg" alt="accenture" />
        <span><img src="assets/images/mywiz.svg" alt="myWizard"></span>
    </div>
    <div class="myw-header-nav d-flex justify-content-end" title={{scopr_title}}>
        <!-- scope selector -->
        <!-- scope selector -->
        <div class="myw-scope dropdown dropright d-flex show" style="margin: 0px 0px">
            <div style="margin-top: 17px;width: auto;height: 16px; font-size: 11px;">
                <span>
                    <a class="scopeSelectd"  title=""
                        style="margin-right: 15px;
                        font-weight: 600;
                        font-size: 14px;
                        color: black;">{{this.ajWebService.scope_title}}
                    </a>
                </span>
                <img src="assets/images/scope.svg" alt="" class="d-lg-none" />
            </div>

        <!-- /scope selector -->
        <!-- <a href="javascript:;" class="myw-header-item myw-help" title="Help">
        <img src="../assets/images/help.svg" alt="Help" />
        <span class="sr-only">Help</span>
      </a>
      <a href="javascript:;" class="myw-header-item myw-notifications" title="Notifications">
        <img src="../assets/images/uva.svg" alt="Notifications" />
        <span class="sr-only">Notifications</span>
      </a>
      <a href="javascript:;" class="myw-header-item myw-settings" title="Settings">
        <img src="../assets/images/settings.svg" alt="Settings" />
        <span class="sr-only">Settings</span>
      </a> -->
        <!-- <div class="dropdown dropright d-flex"> -->
        <!-- <p style="margin:15px -8px;">{{ajWebService.enterpriseId}}</p> -->
        <div class="dropdown dropright dropflat d-flex" style="margin-left: 17px;margin-top: 14px;">
            <a href="javascript:;" class="myw-navbar-action" title="" role="button" data-toggle="dropdown"
                data-display="static" aria-haspopup="true" aria-expanded="true" data-trigger="hover" id="Linkview">
                <img src="assets/images/user.svg" alt="Filter" />
                <img src="assets/images/caret-down.svg" alt="Filter" style="width: 0.6rem;margin-left: 7px;" /></a>


            <div class="dropdown-menu dropdown-small" style="height: 100px;width:13.3rem" aria-labelledby="Linkview">
                <form class="dropdown-body">
                    <p style="margin:15px 8px;">Welcome, <b>{{ajWebService.enterpriseId}}</b></p>

                    <button _ngcontent-tdi-c93="" type="button" class="btn btn-primary" (click)="logOutUser()"
                        style="margin-left: 12px;">Logout</button>
                    <!-- <a (click)="logOutUser()" target="blank" class="dropdown-item">
                        Logout
                        <img src="assets/images/Logout.png" style="left: 3.5rem;" alt="Filter" />
                    </a> -->
                </form>
            </div>
        </div>
        <!-- <a href="javascript:;" class="myw-login myw-header-item dropdown-toggle" role="button" data-display="static"
          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="loginDetails" title="demo.user">
          <img src="../assets/images/user.svg" alt="demo.user" />
          <span class="sr-only">demo.user</span>
        </a> -->
        <!-- <div class="dropdown-menu dropdown-md" aria-labelledby="loginDetails">
          <div class="dropdown-body">
            <div class="p-3">
              <p>Welcome, <strong>demo.user</strong></p>
              <button type="button" class="btn btn-primary">Logout</button>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    </div>
</header>
<!-- /header -->

<!-- topbar -->
<div class="myw-topbar">
    <div class="myw-container d-flex flex-wrap">
        <span style="font-size: 1.125rem;
      font-weight: 600;
      padding: .5rem 0;
      margin-right: 1rem;
      color: #fff;">Automation Journey</span>
    </div>
</div>
<!-- /topbar -->



<router-outlet></router-outlet>